import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import React, { useCallback, useEffect, useRef, useState } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-slideshow-image/dist/styles.css';
import { _endPoints, updatecustomer } from '../Helper/links';
import pattern from '../Helper/pattern';
import API from '../Helper/server/API';
import { useCustomer } from './useCustomer';

function CustomerEditComponet(props) {
    const [loding_set, set_loding_set] = useState(false)
    const {
        // eslint-disable-next-line no-unused-vars
        visitor_name, handel_visitor_name, phone_number, handel_phone_number, whatsapp_number, handel_whatsapp_number, city, set_city, handel_city, note, handel_note, files, handel_files, customer_clear,
        id_customer, setid_customer, setvisitor_name, setphone_number, setwhatsapp_number, set_note, state, set_state, national_number, handel_national_number, verification, set_verification, set_national_number
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useCustomer();


    //____________________________________________________________________________________________
    const fileUploadRef = useRef([]);
    const onTemplateSelectFile = (e, item) => {
        set_identity_document(prevData => prevData.map(index => {
            if (index.ID_identity == item.ID_identity)
                return { ...index, new_file: e.files[0], path_document: null }
            else
                return index
        }))
    };
    const onTemplateClearFiles = (item) => {
        item.file = [];
        set_identity_document(prevData => prevData.map(index => {
            if (index.ID_identity == item.ID_identity)
                return { ...index, path_document: null, new_file: null }
            else
                return index
        }))
    };
    const headerTemplateFile = (options, item, key) => {
        const { className, chooseButton, cancelButton } = options;

        let size = 0;
        if (item?.file?.length > 0 && item.file[0]?.size) {
            size = item.file[0].size;
        }

        // الحجم كنسبة (5MB)
        const value = (size / 5000000) * 100;

        // ref الخاص بالـ FileUpload الحالي
        const fileUpload = fileUploadRef.current[key];

        const formattedValue = fileUpload
            ? fileUpload.formatSize(size)
            : '0 B';

        return (
            <div
                className={className}
                style={{
                    backgroundColor: 'transparent',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <div className="row align-items-center gap-3 ml-auto pr-4">
                    <div>{chooseButton}</div>
                    <div className="pr-3">{cancelButton}</div>
                </div>

                <span dir="ltr">{formattedValue} / 5 MB</span>

                <ProgressBar
                    value={value}
                    showValue={false}
                    style={{ width: '20rem', height: '12px', margin: '1rem' }}
                />
            </div>
        );
    };
    const itemTemplate = (item) => {
        return <></>
    };


    const emptyTemplateFile = () => {
        return (
            <>
                <div className="flex align-items-center flex-column">
                    <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                </div>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)', fontFamily: "Cairo" }} className="my-5">
                    اسحب وأفلِت الصورة هنا
                </span>
            </>
        );
    };
    const chooseOptionsFile = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const cancelOptionsFile = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    const UpdateCustomer = async () => {

        set_loding_set(true);
        var validtion = true
        //_______________________________________________________________________________________
        //                         Validtion
        if (!visitor_name || (pattern.name_ar.test(visitor_name) === false && pattern.name_en.test(visitor_name) === false) || visitor_name === "" || visitor_name.length > 200) {
            validtion = false
            document.getElementById("lvisitor_name").style.color = 'red';
        }
        if (!phone_number || pattern.phone_number.test(phone_number) === false || phone_number === "" || phone_number.toString().length !== 9) {
            validtion = false
            document.getElementById("lphone_number").style.color = 'red';
        }
        if (whatsapp_number !== null && whatsapp_number !== '' &&
            (pattern.number_whatsapp.test(whatsapp_number) === false || whatsapp_number.length < 7 || whatsapp_number.length > 15)
        ) {
            validtion = false
            document.getElementById("lwhatsapp_number").style.color = 'red';
        }
        else if (whatsapp_number !== null && whatsapp_number !== '' && whatsapp_number.slice(0, 4) === '+218' && whatsapp_number.toString().length !== 13) {
            validtion = false
            document.getElementById("lwhatsapp_number").style.color = 'red';
        }
        if (national_number !== null && national_number !== '' && pattern.national_number.test(national_number) === false) {
            validtion = false
            document.getElementById("lnational_number").style.color = 'red';
        }
        if (note !== null && note !== '' &&
            (pattern.name_ar.test(note) === false && pattern.name_en.test(note) === false)
        ) {
            validtion = false
            document.getElementById("lnote").style.color = 'red';
        }
        if (!state && state !== 0 && state !== 1) {
            validtion = false
            document.getElementById("lstate").style.color = 'red';
        }
        if (!verification && verification !== 0 && verification !== 1) {
            validtion = false
            document.getElementById("lverification").style.color = 'red';
        }
        if (!validtion) {
            props.toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.1rem"
                },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: "أرجــو إدخــال بيــانات العميــل"
            });
        }
        else {
            const data = new FormData();
            data.append('id_customer', id_customer);
            data.append('visitor_name', visitor_name);
            data.append('phone_number', phone_number);
            data.append('whatsapp_number', whatsapp_number ? whatsapp_number : null);
            data.append('national_number', national_number);
            data.append('note', note ? note : '');
            data.append('state', state);
            data.append('verification', verification)
            var identity_document_customer = []
            identity_document.map(index => {
                if (index.value_key || index?.new_file || index?.path_document) {
                    if (index?.new_file)
                        data.append('images[]', index?.new_file)
                    identity_document_customer.push(index)
                }
            })
            data.append('identity_document_customer', JSON.stringify(identity_document_customer))
            const response = await API.post(updatecustomer, data)
            if (response?.success) {
                props.toast.current.show({
                    style: {
                        fontSize: "1.2rem",
                        fontFamily: "Cairo"
                    },
                    life: 3000,
                    severity: 'success', summary: ' نجــاح ', detail: response?.msg
                });
                customer_clear()
                props.GetCustomers();
                props.set_show_edit(false);
            }
            else if (response?.success === 0) {
                props.toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 3000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
                if (response?.error === "visitor_name")
                    document.getElementById("lvisitor_name").style.color = "red"
                else if (response?.error === "phone_number")
                    document.getElementById("lphone_number").style.color = "red"
            }
        }
        set_loding_set(false);
    }
    const [identity_document, set_identity_document] = useState([])
    const handel_identity_document_value_key = useCallback((e, item) => {
        set_identity_document(prevData =>
            prevData.map(index => {
                if (
                    index.ID_identity === item.ID_identity
                ) {
                    const regex = new RegExp('^' + index.pattern_kay + '$');
                    if (regex && regex.test(e.target.value)) {

                        document.getElementById(`lname_kay_${index.ID_identity}`).style.color = 'black'
                    }
                    else {
                        document.getElementById(`lname_kay_${index.ID_identity}`).style.color = 'red'
                    }
                    return { ...index, value_key: e.target.value };
                }
                else {
                    return index;
                }
            })
        );
    }, [set_identity_document]);
    const GetCities = async () => {
        const response = await API.get(`${_endPoints.customers.page}`)
        if (response?.success) {
            var new_identity_document = []
            if (!props?.customer?.dentity_document?.length > 0)
                set_identity_document(response.data.identity_document)
            else {
                response.data.identity_document.map(item_new => {
                    var have = false;
                    var set_item = null
                    props?.customer?.dentity_document?.map(item => {
                        if (item_new.ID_identity == item.ID_identity)
                            set_item = item;
                    })
                    if (set_item)
                        new_identity_document.push(set_item)
                    else
                        new_identity_document.push(item_new)
                })
                set_identity_document(new_identity_document)
                new_identity_document = []
            }
        }
    }

    useEffect(() => {
        setid_customer(props?.customer?.ID_customer)
        setvisitor_name(props?.customer?.visitor_name)
        setphone_number(props?.customer?.phone_number)
        if (props?.customer?.whatsapp_number && props?.customer?.whatsapp_number !== "null")
            setwhatsapp_number("+" + props?.customer?.whatsapp_number)
        set_national_number(props?.customer?.national_number)
        set_note(props?.customer?.note)
        set_state(props?.customer?.state)
        set_verification(props?.customer?.verification)
        set_identity_document(props?.customer?.dentity_document)
        GetCities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_identity_document]);
    return (
        <div className="ibox">
            <div className='obox-body'>
                <div className="col-md-12 mt-2">
                    <center>
                        <label id="lstate" style={{ fontSize: "17px", fontWeight: "bold" }}>
                            حالــة  العميــل
                        </label>
                        <br></br>
                        <Button icon={state ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={state ? "فعـــال" : "متــوقف"} outlined severity={state ? "success" : "danger"} size="large" className='mr-1'
                            onClick={(e) => {
                                if (state)
                                    set_state(0)
                                else
                                    set_state(1)
                                document.getElementById("lstate").style.color = 'black';
                                // document.getElementById("lstate").style.color = 'black';
                            }} />
                        {/* <Button icon={state?"pi true-icon pi-check-circle":"pi false-icon pi-times-circle"} rounded text severity={state?"success":"danger"} size="large" className='mr-1'
                        onClick={(e)=>{
                            if(state)
                                set_state(0)
                            else
                                set_state(1)
                            document.getElementById("lstate").style.color = 'black';
                }}/> */}
                    </center>

                </div>
                <hr></hr>
                <div className='col-md-12 mt-4'>

                    <div className="row"  >

                        <div className="col-md-4  mb-4">
                            <label id="lvisitor_name"> الأسم بالكامل *
                                <i className="ti ti-user pr-1" ></i>
                            </label>
                            < label id="msg_customer" style={{ paddingRight: "50px" }}></label>
                            <InputText value={visitor_name}
                                maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{ fontFamily: "Cairo" }} inputStyle={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                                virtualScrollerOptions={{ itemSize: 38 }} field="visitor_name" dropdown onChange={(e) => handel_visitor_name(e)} scrollHeight="400px" />
                        </div>

                        <div className="col-md-2  mb-4">
                            <label id="lphone_number"> رقم الهاتف *
                                <i className="fa fa-phone pr-1" ></i>
                            </label>
                            <div className="p-inputgroup flex-1">
                                <InputText value={phone_number} maxLength={9} placeholder="9x1234567" style={{ fontFamily: "Cairo", textAlign: "left" }}
                                    onChange={(e) => handel_phone_number(e)} />
                                <span className="p-inputgroup-addon" dir='ltr' style={{ borderRight: "0 nane", borderLeft: "1px solid #ced4da" }}>+218</span>

                            </div>
                        </div>
                        <div className="col-md-3  mb-4">
                            <label id="lwhatsapp_number"> رقم واتس اب
                                <i className="fa fa-whatsapp pr-1" ></i>
                            </label>
                            <div className="input-group" dir="ltr">
                                <PhoneInput
                                    country='LY'
                                    showValue
                                    // defaultCountry="LY"
                                    placeholder="ادخل رقم واتس اب"
                                    value={whatsapp_number} maxLength={15} name="whatsapp_number" id="whatsapp_number"
                                    onChange={handel_whatsapp_number}
                                    className="p-inputtext p-component p-autocomplete-input p-autocomplete-dd-input p-autocomplete-input p-autocomplete-dd-input col-md-12 pr-0"
                                />
                            </div>
                        </div>

                        <div className="col-md-3  mb-4">
                            <label id="lnational_number" clas>  رقم الوطني
                                <i className="ti ti-key pr-1" ></i>
                            </label>
                            < label id="msg_national_number" ></label>
                            <InputText value={national_number}
                                maxLength={12} placeholder="x1990xxxxxxx" className="col-md-12 "
                                field="national_number" dropdown onChange={(e) => handel_national_number(e)} />
                        </div>
                        <div className="col-md-12 mb-4" >
                            <label id="lnote"> ملاحظـــــة
                                <i className="ti ti-note pr-1" ></i>
                            </label>
                            <br></br>
                            <InputTextarea maxLength={1000} value={note} onChange={(e) => handel_note(e)} cols={200} />
                        </div>
                    </div>
                    <hr></hr>
                    <div className="col-md-12  mb-4">
                        <label id="lverification" className='col-md-12'> التحـــقق مـن الهويـــة
                            <i className="ti ti-note pr-1" ></i>
                        </label>
                        <Button icon={verification ? "pi true-icon pi-check ml-2" : "pi false-icon pi-times ml-2"} label={verification ? "تــــم التحـــقق" : "لم يتـم التحــقق"} outlined severity={verification ? "success" : "danger"} size="large" className='mr-1'
                            onClick={(e) => {
                                if (verification)
                                    set_verification(0)
                                else
                                    set_verification(1)
                                // document.getElementById("lstate").style.color = 'black';
                            }} />
                    </div>
                    <div class="clf" key={1}>
                        <ul class="nav nav-tabs tabs-line nav-fill">
                            {identity_document.map((item, key) => {
                                return <li class="nav-item">
                                    <a class={key == 0 ? "nav-link active" : "nav-link"} href={`#tab-${key}`} data-toggle="tab">
                                        <h6>  {item.name_identity}</h6>
                                    </a>
                                </li>
                            })}
                        </ul>
                        <div class="tab-content mt-5">
                            {identity_document.map((item, key) => {
                                return <div class={key == 0 ? "tab-pane show active" : "tab-pane"} id={`tab-${key}`}>
                                    <>
                                        <div className='col-md-12'>
                                            <div className="row">
                                                <div className="col-md-4  mb-4">
                                                    {item.name_kay ?
                                                        <>
                                                            <label id={`lname_kay_${item.ID_identity}`}> {item.name_kay} *
                                                                <i className="ti ti-key pr-1" ></i>
                                                            </label>
                                                            < label id={`msg_name_kay_${key}`} style={{ paddingRight: "50px" }}></label>
                                                            <InputText value={item.value_key}
                                                                maxLength={10} placeholder={`ادخال ${item.name_kay}`} className="col-md-12 " style={{ fontFamily: "Cairo" }} inputStyle={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                                                                virtualScrollerOptions={{ itemSize: 38 }} field={`name_kay_${key}`} dropdown
                                                                onChange={(e) => handel_identity_document_value_key(e, item)} scrollHeight="400px" />
                                                        </>
                                                        : null
                                                    }
                                                </div>

                                                <div className="col-md-8 " >
                                                    <label id="lwhatsapp_number">وثيــقة {item.name_identity}
                                                        <i className="ti ti-file pr-1" ></i>
                                                    </label>
                                                    <Tooltip target=".custom-choose-btn" content="اختار" position="bottom" style={{ fontFamily: "Cairo" }} />
                                                    <Tooltip target=".custom-upload-btn" content="رفع" position="bottom" style={{ fontFamily: "Cairo" }} />
                                                    <Tooltip target=".custom-cancel-btn" content="تفريغ" position="bottom" style={{ fontFamily: "Cairo" }} />
                                                    <FileUpload ref={(el) => (fileUploadRef.current[key] = el)} name="demo[]" url="/api/upload" accept="image/jpeg,image/jpg,image/png" maxFileSize={5000000} multiple={false} id={`input_file_${item.ID_identity}`}
                                                        onSelect={(e) => onTemplateSelectFile(e, item)} onError={onTemplateClearFiles} onClear={() => onTemplateClearFiles(item)}
                                                        headerTemplate={(e) => headerTemplateFile(e, item, key)} itemTemplate={(e) => itemTemplate} emptyTemplate={item.path_document ? null : emptyTemplateFile} style={{ textAlign: "center" }}
                                                        chooseOptions={chooseOptionsFile} cancelOptions={cancelOptionsFile} />
                                                    <div >
                                                        {
                                                            item?.new_file || item?.path_document ?
                                                                <div className="card flex justify-content-center">
                                                                    <div className="grid">
                                                                        <div
                                                                            className="col-md-12"
                                                                            style={{
                                                                                maxHeight: "500px",
                                                                                overflowY: "auto",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                key={key}
                                                                                className="row"

                                                                                style={{
                                                                                    border: "1px  #ccc",
                                                                                    borderRadius: "8px",
                                                                                }}
                                                                            >
                                                                                <div className="col-md-6">
                                                                                    <Image src={item.path_document ? _endPoints.customers.files + item.path_document : item?.new_file?.objectURL} alt={item.name_identity} width="250" preview style={{ cursor: "grab", objectFit: "cover" }} />
                                                                                </div>

                                                                                <div className="col-md-4">
                                                                                    <br />
                                                                                    <br />
                                                                                    {item.path_document ? item.path_document : item?.new_file?.name}
                                                                                    <br />
                                                                                    {
                                                                                        item?.new_file?.size ?
                                                                                            <Tag
                                                                                                value={`${(item?.new_file?.size / 1048576).toFixed(2)} MB`}
                                                                                                severity="warning"
                                                                                                className="px-3 py-2 p-2"
                                                                                            />
                                                                                            : null
                                                                                    }
                                                                                    <br />
                                                                                </div>

                                                                                <div className="col-md-2">
                                                                                    <br />
                                                                                    <Button
                                                                                        type="button"
                                                                                        icon="pi pi-times"
                                                                                        className="p-button-outlined p-button-rounded p-button-danger ml-auto mt-5"
                                                                                        onClick={(e) => {
                                                                                            fileUploadRef.current[key].clear();
                                                                                            onTemplateClearFiles(item)

                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                : null
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className='row' style={{ paddingTop: "2rem" }}>
                        <div className="col-md-12" style={{ paddingTop: "40px" }}>
                            <center>
                                <Button label=" تعــديــل العميــــل " dir='rtl' raised className="pl-4 pr-4" style={{ fontFamily: "Cairo", margin: "1" }} onClick={UpdateCustomer} loading={loding_set} />
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerEditComponet